/**
 * Maipic Buy Panel – Produkt, S/M/L/XL, Extras, Warenkorb.
 * Wird vom Text-zu-Bild Studio gemountet. Kein Cropper.
 */
(function () {
  'use strict';

  var SIZE_MAP = {
    '1:1': {
      S: { w: 20, h: 20 },
      M: { w: 30, h: 30 },
      L: { w: 40, h: 40, preferred: true },
      XL: { w: 60, h: 60 }
    },
    '3:2': {
      S: { w: 30, h: 20 },
      M: { w: 60, h: 40, preferred: true },
      L: { w: 90, h: 60 },
      XL: { w: 120, h: 80 }
    },
    '2:3': {
      S: { w: 20, h: 30, skuW: 30, skuH: 20, rotate: true },
      M: { w: 40, h: 60, skuW: 60, skuH: 40, rotate: true, preferred: true },
      L: { w: 60, h: 90, skuW: 90, skuH: 60, rotate: true },
      XL: { w: 80, h: 120, skuW: 120, skuH: 80, rotate: true }
    },
    '2:1': {
      S: { w: 40, h: 20 },
      M: { w: 60, h: 30 },
      L: { w: 80, h: 40, preferred: true },
      XL: { w: 100, h: 50 }
    },
    '1:2': {
      S: { w: 20, h: 40, skuW: 40, skuH: 20, rotate: true },
      M: { w: 30, h: 60, skuW: 60, skuH: 30, rotate: true },
      L: { w: 40, h: 80, skuW: 80, skuH: 40, rotate: true, preferred: true },
      XL: { w: 50, h: 100, skuW: 100, skuH: 50, rotate: true }
    }
  };

  /* Kissen nur Quadrat, Shop-SKUs: 30 / 40 / 60 — kein 20×20, kein 80×80. */
  var PILLOW_SIZE_MAP = {
    '1:1': {
      S: { w: 30, h: 30 },
      M: { w: 40, h: 40, preferred: true },
      L: { w: 60, h: 60 }
    }
  };

  /* MixPix: eine SKU 20×20, nur Quadrat. */
  var MIXPIX_SIZE_MAP = {
    '1:1': {
      M: { w: 20, h: 20, preferred: true }
    }
  };

  /* Sporthandtuch: eine SKU 140×70 (2:1). 1:2 = dasselbe Tuch, gedreht. */
  var TOWEL_SIZE_MAP = {
    '2:1': {
      M: { w: 140, h: 70, preferred: true }
    },
    '1:2': {
      M: { w: 70, h: 140, skuW: 140, skuH: 70, rotate: true, preferred: true }
    }
  };

  var KNOWN_FORMATS = { '1:1': 1, '3:2': 1, '2:3': 1, '1:2': 1, '2:1': 1 };
  var FORMAT_RATIO = { '1:1': 1, '3:2': 1.5, '2:3': 2 / 3, '2:1': 2, '1:2': 0.5 };
  var SIZE_ORDER = ['S', 'M', 'L', 'XL', 'XXL'];

  function sizeMapFor(format, type) {
    if (type === 'pillow') return PILLOW_SIZE_MAP[format] || {};
    if (type === 'mixpix') return MIXPIX_SIZE_MAP[format] || {};
    if (type === 'towel') return TOWEL_SIZE_MAP[format] || {};
    var map = SIZE_MAP[format] || {};
    if (type === 'canvas' && format === '1:1') {
      return Object.assign({}, map, { XXL: { w: 80, h: 80 } });
    }
    return map;
  }

  function mugSideOf(v) {
    var blob = [v && v.sku, v && v.title, sizeLabelFromVariant(v)].join(' ').toLowerCase();
    if (/leftptr|left|links/.test(blob)) return 'left';
    if (/rigtptr|rightptr|right|rechts/.test(blob)) return 'right';
    return '';
  }

  function mugSizesFor(product) {
    var bySide = { left: null, right: null };
    (product && product.variants || []).forEach(function (v) {
      var side = mugSideOf(v);
      if (side && !bySide[side]) bySide[side] = v;
    });
    if (!bySide.left && !bySide.right) {
      var vs = (product && product.variants) || [];
      if (vs[0]) bySide.left = vs[0];
      if (vs[1]) bySide.right = vs[1];
    }
    var out = [];
    ['left', 'right'].forEach(function (side) {
      if (!bySide[side]) return;
      out.push({
        key: side,
        spec: { side: side, preferred: side === 'right' },
        variant: bySide[side],
        label: 'Portrait'
      });
    });
    return out;
  }

  function ratioClose(a, b) {
    return Math.abs(Number(a) - Number(b)) < 0.06;
  }

  function dimsMatchFormat(d, format) {
    if (!d || !d.w || !d.h || !FORMAT_RATIO[format]) return null;
    var target = FORMAT_RATIO[format];
    if (ratioClose(d.w / d.h, target)) {
      return { w: d.w, h: d.h, skuW: d.w, skuH: d.h, rotate: false };
    }
    if (ratioClose(d.h / d.w, target)) {
      return { w: d.h, h: d.w, skuW: d.w, skuH: d.h, rotate: true };
    }
    return null;
  }

  function packSizeKeys(list) {
    list.sort(function (a, b) {
      return (a.spec.w * a.spec.h) - (b.spec.w * b.spec.h);
    });
    return list.slice(0, SIZE_ORDER.length).map(function (s, i) {
      s.key = SIZE_ORDER[i];
      return s;
    });
  }

  function availableSizesFor(product, format, type) {
    if (type === 'mug') return format === '1:1' ? mugSizesFor(product) : [];
    var map = sizeMapFor(format, type);
    var out = [];
    var used = {};
    SIZE_ORDER.forEach(function (key) {
      var spec = map[key];
      if (!spec || !product) return;
      var variant = findVariant(product, spec.skuW || spec.w, spec.skuH || spec.h);
      if (!variant) return;
      used[variant.id] = true;
      out.push({
        key: key,
        spec: spec,
        variant: variant,
        label: spec.w + '×' + spec.h
      });
    });
    if (out.length || !product) return packSizeKeys(out);
    (product.variants || []).forEach(function (v) {
      if (used[v.id]) return;
      var match = dimsMatchFormat(parseDims(sizeLabelFromVariant(v)), format);
      if (!match) return;
      if (type === 'canvas' && (
        (match.w === 150 && match.h === 100) ||
        (match.w === 100 && match.h === 150)
      )) return;
      out.push({
        key: 'M',
        spec: {
          w: match.w,
          h: match.h,
          skuW: match.skuW,
          skuH: match.skuH,
          rotate: match.rotate,
          preferred: true
        },
        variant: v,
        label: match.w + '×' + match.h
      });
    });
    return packSizeKeys(out);
  }

  function entryHasFormat(entry, format) {
    return !!(entry && availableSizesFor(entry.product, format, entry.def && entry.def.type).length);
  }

  var PRODUCT_DEFS = [
    { keys: ['leinwand', 'canvas'], type: 'canvas', wall: true, label: 'Leinwand', popular: true },
    { keys: ['metall', 'metal', 'alu'], type: 'metal', wall: true, label: 'Metall' },
    { keys: ['acryl', 'acrylic'], type: 'acrylic', wall: true, label: 'Acrylglas' },
    { keys: ['poster', 'plakat'], type: 'poster', wall: true, label: 'Poster' },
    { keys: ['holz', 'wood'], type: 'wood', wall: true, label: 'Holztafel' },
    { keys: ['kissen', 'pillow', 'cushion'], type: 'pillow', wall: false, label: 'Kissen' },
    { keys: ['mixpix', 'mix-pix', 'fotokachel'], type: 'mixpix', wall: true, label: 'Fotokachel' },
    { keys: ['sporthandtuch', 'handtuch', 'towel'], type: 'towel', wall: false, label: 'Sporthandtuch' },
    { keys: ['tasse', 'mug', 'becher'], type: 'mug', wall: false, label: 'Tasse' }
  ];

  function money(cents) {
    return (Number(cents || 0) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function parseDims(label) {
    var m = String(label || '').match(/(\d+)\s*[x×]\s*(\d+)/i);
    return m ? { w: Number(m[1]), h: Number(m[2]) } : null;
  }

  function sizeLabelFromVariant(v) {
    var so = (v && v.selectedOptions || []).find(function (o) {
      return /size|größe|format/i.test(o.name || '');
    });
    return (so && so.value) || (v && v.title) || '';
  }

  function findVariant(product, w, h) {
    if (!product || !w || !h) return null;
    return (product.variants || []).find(function (v) {
      var d = parseDims(sizeLabelFromVariant(v));
      return d && d.w === w && d.h === h;
    }) || null;
  }

  function matchDef(product) {
    var h = String(product.handle || '').toLowerCase();
    var t = String(product.title || '').toLowerCase();
    return PRODUCT_DEFS.find(function (d) {
      return d.keys.some(function (k) { return h.indexOf(k) !== -1 || t.indexOf(k) !== -1; });
    }) || null;
  }

  function flattenProducts(data) {
    var seen = {};
    var out = [];
    (data && data.categories || []).forEach(function (cat) {
      (cat.products || []).forEach(function (p) {
        if (!p || seen[p.id]) return;
        seen[p.id] = true;
        var def = matchDef(p);
        if (!def) return;
        out.push({ product: p, def: def });
      });
    });
    out.sort(function (a, b) {
      return PRODUCT_DEFS.indexOf(a.def) - PRODUCT_DEFS.indexOf(b.def);
    });
    return out;
  }

  function extraPitch(type, spec) {
    var w = Number(spec && spec.w || 0);
    var h = Number(spec && spec.h || 0);
    var from60 = Math.min(w, h) >= 60;
    if (type === 'metal' || type === 'acrylic') {
      return from60
        ? 'Aluminium Backframe - fertig zum Aufhängen'
        : 'Magnofix - hält ohne Bohren';
    }
    if (type === 'wood' || type === 'canvas') return 'Aufhängeset - fertig zum Aufhängen';
    if (type === 'mixpix') return 'Magnofix - hält ohne Bohren';
    if (type === 'pillow') return 'mit Füllung';
    return '';
  }

  function printIdFromKey(key) {
    var clean = String(key || '').replace(/^\/+/, '').replace(/^https?:\/\/[^/]+\//, '');
    clean = clean.replace(/^cdn-cgi\/image\/[^/]+\//, '');
    return clean.replace(/\.(jpe?g|png|webp)$/i, '');
  }

  function cartPreviewUrl(image) {
    var fromDisplay = String((image && image.displayUrl) || '');
    if (/^https:\/\/img\.maipic\.de\//i.test(fromDisplay)) return fromDisplay;
    var id = printIdFromKey(image && image.key);
    if (!id || /[<>'"\\\s]/.test(id)) return '';
    return 'https://img.maipic.de/cdn-cgi/image/width=360,quality=80,format=auto/' + id + '.jpg';
  }

  function MaipicBuyPanel(root, opts) {
    this.root = root;
    this.opts = opts || {};
    this.catalog = flattenProducts(this.readData());
    this.format = '1:1';
    this.image = { key: '', displayUrl: '' };
    this.entry = null;
    this.sizeKey = '';
    this.variant = null;
    this.els = {
      products: root.querySelector('.mp-buy-products'),
      unsupported: root.querySelector('.mp-buy-unsupported'),
      unsupportedList: root.querySelector('.mp-buy-unsupported-list'),
      sizes: root.querySelector('.mp-buy-sizes'),
      extras: root.querySelector('.mp-buy-extras-copy'),
      price: root.querySelector('.mp-buy-atc-price'),
      atc: root.querySelector('.mp-buy-atc'),
      note: root.querySelector('.mp-buy-status')
    };
    this.bind();
    this.pickDefaultProduct();
    this.syncVariant();
    this.render();
  }

  MaipicBuyPanel.prototype.readData = function () {
    var node = this.root.querySelector('.mp-buy-data');
    if (!node) return { categories: [] };
    try { return JSON.parse(node.textContent || '{}'); } catch (e) { return { categories: [] }; }
  };

  MaipicBuyPanel.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var prod = e.target.closest('[data-buy-product]');
      if (prod) {
        if (prod.hasAttribute('disabled')) return;
        self.selectProduct(prod.getAttribute('data-buy-product'));
        return;
      }
      var size = e.target.closest('[data-buy-size]');
      if (size && !size.hasAttribute('disabled')) {
        self.sizeKey = size.getAttribute('data-buy-size');
        self.syncVariant();
        self.render();
      }
    });
    if (this.els.atc) {
      self.els.atc.addEventListener('click', function () { self.addToCart(); });
    }
  };

  MaipicBuyPanel.prototype.pickDefaultProduct = function () {
    var canvas = this.catalog.find(function (e) { return e.def.type === 'canvas'; });
    this.entry = canvas || this.catalog[0] || null;
  };

  function sizeByDims(sizes, spec) {
    if (!spec) return null;
    var w = Number(spec.w || 0);
    var h = Number(spec.h || 0);
    var skuW = Number(spec.skuW || spec.w || 0);
    var skuH = Number(spec.skuH || spec.h || 0);
    return sizes.find(function (s) {
      return (s.spec.w === w && s.spec.h === h)
        || ((s.spec.skuW || s.spec.w) === skuW && (s.spec.skuH || s.spec.h) === skuH)
        || (s.spec.w === h && s.spec.h === w);
    }) || null;
  }

  MaipicBuyPanel.prototype.setFormat = function (aspect) {
    var prev = this.availableSizes().find(function (s) { return s.key === this.sizeKey; }, this);
    this.format = KNOWN_FORMATS[aspect] ? aspect : '1:1';
    if (this.entry && !entryHasFormat(this.entry, this.format)) {
      var fmt = this.format;
      var next = this.catalog.find(function (e) { return entryHasFormat(e, fmt); });
      this.entry = next || this.entry;
    }
    var keep = sizeByDims(this.availableSizes(), prev && prev.spec);
    this.sizeKey = keep ? keep.key : '';
    this.syncVariant();
    this.render();
  };

  MaipicBuyPanel.prototype.setImage = function (image) {
    this.image = image || { key: '', displayUrl: '' };
    this.renderPrice();
  };

  MaipicBuyPanel.prototype.selectProduct = function (handle) {
    var entry = this.catalog.find(function (e) { return e.product.handle === handle; });
    if (!entry) return;
    if (!entryHasFormat(entry, this.format)) return;
    var prev = this.availableSizes().find(function (s) { return s.key === this.sizeKey; }, this);
    this.entry = entry;
    var keep = sizeByDims(this.availableSizes(), prev && prev.spec);
    this.sizeKey = keep ? keep.key : '';
    this.syncVariant();
    this.render();
    this.emitProduct();
  };

  MaipicBuyPanel.prototype.setSize = function (key) {
    if (!key) return;
    var sizes = this.availableSizes();
    var known = SIZE_ORDER.indexOf(key) !== -1 || key === 'left' || key === 'right';
    if (!known && !sizes.some(function (s) { return s.key === key; })) return;
    this.sizeKey = key;
    this.syncVariant();
    this.render();
  };

  MaipicBuyPanel.prototype.extraLines = function () {
    if (!this.entry) return [];
    var sizes = this.availableSizes();
    var hit = sizes.find(function (s) { return s.key === this.sizeKey; }, this);
    var pitch = extraPitch(this.entry.def.type, hit && hit.spec);
    return pitch ? [pitch] : [];
  };

  MaipicBuyPanel.prototype.availableSizes = function () {
    if (!this.entry) return [];
    return availableSizesFor(this.entry.product, this.format, this.entry.def.type);
  };

  MaipicBuyPanel.prototype.syncVariant = function () {
    var sizes = this.availableSizes();
    var hit = sizes.find(function (s) { return s.key === this.sizeKey; }, this);
    if (!hit) {
      hit = sizes.find(function (s) { return s.spec.preferred; }) || sizes[0] || null;
      this.sizeKey = hit ? hit.key : 'M';
    }
    this.variant = hit ? hit.variant : null;
  };

  MaipicBuyPanel.prototype.render = function () {
    this.renderProducts();
    this.renderSizes();
    this.renderExtras();
    this.renderPrice();
    this.emitProduct();
    if (typeof this.opts.onStateChange === 'function') {
      this.opts.onStateChange({
        handle: this.entry && this.entry.product.handle,
        sizeKey: this.sizeKey,
        format: this.format,
        type: this.entry ? this.entry.def.type : 'canvas'
      });
    }
  };

  MaipicBuyPanel.prototype.renderProducts = function () {
    var el = this.els.products;
    if (!el) return;
    if (!this.catalog.length) {
      el.innerHTML = '<p class="mp-buy-empty">Keine passenden Produkte in der Kollektion.</p>';
      if (this.els.unsupported) this.els.unsupported.hidden = true;
      return;
    }
    var self = this;
    var allowed = [];
    var blocked = [];
    this.catalog.forEach(function (e) {
      if (entryHasFormat(e, self.format)) allowed.push(e);
      else blocked.push(e);
    });
    var chip = function (e, disabled) {
      var active = !disabled && self.entry && self.entry.product.id === e.product.id;
      var title = disabled ? ' title="Mit einem anderen Format verfügbar"' : '';
      var badge = !disabled && e.def.popular ? '<span class="mp-buy-chip-pop">Beliebt</span>' : '';
      return (
        '<button type="button" class="mp-buy-chip' + (active ? ' is-active' : '') + '"' +
        ' data-buy-product="' + e.product.handle + '"' +
        (disabled ? ' disabled' + title : '') +
        '>' + e.def.label + badge + '</button>'
      );
    };
    el.innerHTML = allowed.length
      ? allowed.map(function (e) { return chip(e, false); }).join('')
      : '<p class="mp-buy-empty">Für dieses Format ist kein Produkt verfügbar.</p>';
    if (this.els.unsupported) this.els.unsupported.hidden = !blocked.length;
    if (this.els.unsupportedList) {
      this.els.unsupportedList.innerHTML = blocked.map(function (e) { return chip(e, true); }).join('');
    }
  };

  MaipicBuyPanel.prototype.renderSizes = function () {
    var el = this.els.sizes;
    if (!el) return;
    var sizes = this.availableSizes();
    var self = this;
    var solo = sizes.length === 1;
    el.classList.toggle('is-solo', solo);
    if (!sizes.length) {
      el.innerHTML = '<p class="mp-buy-empty">Für dieses Format ist keine Größe verfügbar.</p>';
      return;
    }
    el.innerHTML = sizes.map(function (s) {
      var active = s.key === self.sizeKey;
      var mugSide = s.spec && s.spec.side;
      var letter = mugSide ? (mugSide === 'left' ? 'Links' : 'Rechts') : (solo ? 'Einheitsgröße' : s.key);
      var dim = mugSide
        ? '<span class="mp-buy-size-d">Portrait</span>'
        : '<span class="mp-buy-size-d">' + s.label + ' cm</span>';
      var recOn = !solo && s.spec.preferred;
      var rec = '<span class="mp-buy-size-rec' + (recOn ? '' : ' is-ghost') + '"' +
        (recOn ? '' : ' aria-hidden="true"') + '>Empfohlen</span>';
      return (
        '<button type="button" class="mp-buy-size' + (active ? ' is-active' : '') + '"' +
        ' data-buy-size="' + s.key + '"' +
        (solo ? ' aria-disabled="true"' : '') +
        '>' +
        '<span class="mp-buy-size-k">' + letter + '</span>' +
        dim + rec +
        '</button>'
      );
    }).join('');
  };

  MaipicBuyPanel.prototype.renderExtras = function () {
    var info = this.root.querySelector('.mp-buy-facts-info');
    var box = this.root.querySelector('.mp-buy-extras');
    var copy = this.root.querySelector('.mp-buy-extras-copy');
    var lines = this.extraLines();
    var url = this.entry && this.entry.product.url ? String(this.entry.product.url) : '';
    var label = this.entry && this.entry.def.label ? this.entry.def.label : 'Produkt';
    if (info) {
      var caption = info.querySelector('.mp-buy-facts-info-label');
      if (url) {
        info.hidden = false;
        info.href = url;
        if (caption) caption.textContent = 'Informationen zu ' + label;
      } else {
        info.hidden = true;
        info.removeAttribute('href');
      }
    }
    if (copy) copy.textContent = lines[0] || '\u00a0';
    if (box) box.classList.toggle('is-empty', !lines.length);
  };

  MaipicBuyPanel.prototype.startAtcProgress = function () {
    var self = this;
    this.stopAtcProgress();
    this.root.querySelectorAll('.mp-buy-atc-progress').forEach(function (n) { n.hidden = false; });
    var fills = this.root.querySelectorAll('.mp-buy-atc-progress-fill');
    var start = performance.now();
    var tick = function (now) {
      var t = Math.min(1, (now - start) / 8000);
      var p = (1 - Math.pow(1 - t, 2)) * 90;
      fills.forEach(function (f) { f.style.width = Math.round(p) + '%'; });
      self._atcProg = requestAnimationFrame(tick);
    };
    this._atcProg = requestAnimationFrame(tick);
  };

  MaipicBuyPanel.prototype.finishAtcProgress = function () {
    this.stopAtcProgress();
    this.root.querySelectorAll('.mp-buy-atc-progress-fill').forEach(function (f) { f.style.width = '100%'; });
  };

  MaipicBuyPanel.prototype.stopAtcProgress = function () {
    if (this._atcProg) cancelAnimationFrame(this._atcProg);
    this._atcProg = null;
  };

  MaipicBuyPanel.prototype.hideAtcProgress = function () {
    this.stopAtcProgress();
    this.root.querySelectorAll('.mp-buy-atc-progress').forEach(function (n) { n.hidden = true; });
    this.root.querySelectorAll('.mp-buy-atc-progress-fill').forEach(function (f) { f.style.width = '0'; });
  };

  MaipicBuyPanel.prototype.setAtcState = function (disabled, label) {
    if (!this.els.atc) return;
    this.els.atc.disabled = !!disabled;
    var lab = this.els.atc.querySelector('.mp-buy-atc-label');
    if (label && lab) lab.textContent = label;
  };

  MaipicBuyPanel.prototype.renderPrice = function () {
    var total = Number(this.variant && this.variant.priceCents || 0);
    var text = this.variant ? money(total) : '—';
    if (this.els.price) this.els.price.textContent = text;
    var mismatch = this.image.aspect && this.image.aspect !== this.format;
    this.setAtcState(!this.variant || !this.image.key || mismatch);
  };

  MaipicBuyPanel.prototype.emitProduct = function () {
    var type = this.entry ? this.entry.def.type : 'canvas';
    var wall = this.entry ? this.entry.def.wall : true;
    this.root.dispatchEvent(new CustomEvent('maipic:product-change', {
      bubbles: true,
      detail: { type: type, wall: wall, format: this.format, sizeKey: this.sizeKey }
    }));
    if (typeof this.opts.onProductChange === 'function') {
      this.opts.onProductChange({ type: type, wall: wall, format: this.format, sizeKey: this.sizeKey });
    }
  };

  MaipicBuyPanel.prototype.setStatus = function (msg) {
    if (this.els.note) this.els.note.textContent = msg || '';
  };

  MaipicBuyPanel.prototype.freeProps = function () {
    var lines = this.extraLines();
    if (!lines.length) return {};
    return { Gratis: lines.join(' · ') };
  };

  MaipicBuyPanel.prototype.addToCart = async function () {
    if (!this.variant || !this.image.key) return;

    var lab = this.els.atc && this.els.atc.querySelector('.mp-buy-atc-label');
    var original = (lab && lab.textContent) || 'In den Warenkorb';
    this.setAtcState(true, 'In den Warenkorb…');
    this.startAtcProgress();
    this.setStatus('');

    var sizeHit = this.availableSizes().find(function (s) { return s.key === this.sizeKey; }, this);
    var spec = (sizeHit && sizeHit.spec) || {};
    var printId = printIdFromKey(this.image.key);

    var previewUrl = cartPreviewUrl(this.image);
    var props = Object.assign({}, this.freeProps(), {
      _group_id: printId,
      _is_main: 'true',
      _bild_id: printId,
      _crop_id: printId
    });
    if (previewUrl) props._crop_image_url = previewUrl;
    if (spec.rotate) props._rotate = '90';

    try {
      this.finishAtcProgress();
      var cartRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: String(this.variant.id),
            quantity: 1,
            properties: props
          }]
        })
      });
      if (!cartRes.ok) throw new Error('cart');

      this.setAtcState(true, 'Hinzugefügt!');
      window.setTimeout(function () { window.location.href = '/cart'; }, 800);
    } catch (err) {
      this.hideAtcProgress();
      this.setStatus('Konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.');
      this.setAtcState(false, original);
    }
  };

  window.MaipicBuyPanel = {
    mount: function (root, opts) {
      if (!root) return null;
      var panel = new MaipicBuyPanel(root, opts || {});
      root._maipicBuyPanel = panel;
      return panel;
    }
  };
})();
